export default "__VITE_ASSET__DMcPh5WN__"